import type { FaireProductEntity } from "../../entity_types/product";

export const p_euf6kj389k: FaireProductEntity = {
  token: "p_euf6kj389k",
  type: "product",
  name: "Into The Forest Scented Candle",
  brandToken: "b_n3p34d576a",
  brandName: "Nette",
  imageUrl:
    "https://cdn.faire.com/fastly/cded0d3b29c42b70fab08c3ad896c2f0df16222e58c9326ea79d9414728e0fe1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5bf123e9e1d31f0ff59bc7c1e93c8d2514cffeb1ac834f3477af89486324189.jpeg",
    "https://cdn.faire.com/fastly/84bf322a6e88a5c29af8dee413af94d3e9951facd32be45ba003d72827e2b690.jpeg",
    "https://cdn.faire.com/fastly/ea8a97f1fe7d7470685050ed38b8e02365fa313e129cfd64095e89aca838b693.jpeg",
  ],
  priceDollars: 41,
  description:
    "\n\nFRAGRANCE NOTES\n\nTop: Cypress, Pine Needle Siberia, Black Pepper LMR, Orange Sicily\nMid: Fir Balsam Needle Canada, Cardamom, Rosemary Tunisia, Clove Leaf, Ciste Labdanum\nBase: Olibanum, Cedarwood Virginia, Tonka Bean, Patchouli Indonesia, Vanilla\n\nPRODUCT DETAILS\nHand-Poured Coconut and Soy Wax Candle\n\n\n11 oz (312 g) \n\nBurn Time: 65 hours \n\nHandmade ceramic vessel that is food-safe, microwave-safe, and dishwasher-safe. Use as your new favorite mug when the candle is done! \n\nDESCRIPTION\n\nThrough the trees we rise. Sunlight streams through an autumn breeze. A palace of cypress and cedar. Moss covered rocks like silk on slate. The rings of a trunk, the lines of a thumb. We have different names; but we are the same.\n\n\n\n\n\n\n\n\nRETURNS\n\nPlease review our Returns Policy and email [redacted-email] with any questions or requests.\n",
  tags: [],
  msrpDollars: 82,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:58.296Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
